import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-permission-component',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss']
})
export class PermissionsComponent implements OnInit {
  @Input()
  public rowData: any;
  @Input()
  public value: string | number;

  @Output() canModifyContract: EventEmitter<any> = new EventEmitter<any>();
  @Output() canEditCompany: EventEmitter<any> = new EventEmitter<any>();
  @Output() canViewInformation: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  setCanModifyContract() {
    this.canModifyContract.emit({
      canChangeSupplierContract: !this.rowData.canChangeSupplierContract,
      email: this.rowData.email,
      id: this.rowData.id
    });
  }

  setCanEditCompany() {
    this.canEditCompany.emit({
      canEditInformation: !this.rowData.canEditInformation,
      email: this.rowData.email,
      id: this.rowData.id
    });
  }

  setCanViewInformation() {
    this.canViewInformation.emit({
      canViewInformation: !this.rowData.canViewInformation,
      email: this.rowData.email,
      id: this.rowData.id
    });
  }
}
